import { render, staticRenderFns } from "./appliedStatistics.vue?vue&type=template&id=50cb76e2&scoped=true&"
import script from "./appliedStatistics.vue?vue&type=script&lang=js&"
export * from "./appliedStatistics.vue?vue&type=script&lang=js&"
import style0 from "./appliedStatistics.vue?vue&type=style&index=0&id=50cb76e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb76e2",
  null
  
)

export default component.exports